import React from 'react';
import PropTypes from 'prop-types';

import Icon, { ICON_NAMES } from 'components/Icon';


function CheckboxMarker(props) {
  const { className, isChecked } = props;

  return (
    <span className={`checkbox-marker`}>
      <Icon name={ICON_NAMES.check} active={isChecked === 1 || isChecked} className={isChecked || isChecked === 1 ? 'icon-check icon-check--active' : 'icon-check'} />
    </span>
  )
}


CheckboxMarker.defaultProps = {
  className: ''
}

CheckboxMarker.propTypes = {
  isChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  className: PropTypes.string
}


export default CheckboxMarker;